export default __webpack_public_path__ + "static/media/file_blue.9fdf0416.svg";